import React from 'react';

interface IPresetMenu {
    style?: React.CSSProperties;
}

const PresetMenu = (props: IPresetMenu) => {
    return (
        <div style={props.style}>
            <div className="centumvp_left_panel_main_name">
                <h3 style={{ color: '#ffffff', margin: '3px' }}>Preset Menu</h3>
            </div>
        </div>
    );
};

export default PresetMenu;
